import React from 'react'
import TalkingAboutUsPage from '../parts/pages/TalkingAboutUsPage'

export default function TalkingAboutUs() {
  return <TalkingAboutUsPage />
}
